<template>
	<div
    v-if = "supportedChannels && supportedChannels.length"
    class = "channels-main-wrapper">
		<p v-if = "placeholder">{{ placeholder }}</p>
		<p>
			<span
			  v-for = "(channel, c) in supportedChannels"
			  :key = "c"
        :title="channel"
			  :class = "[ getIcon(channel), 'platform-wrapper capitalize' ]">{{ fallbackToText && !getIcon(channel) ? channel : null }}</span>
		</p>
	</div>
</template>

<script>
export default {
  name: 'SupportedPlatforms',
  props: {
    placeholder: {
      type: [String, Boolean],
      default: 'Platforms Supported By This Card'
    },
    slug: {
      type: String,
      default: 'card-text'
    },
    manualChannels: {
      type: Array,
      default: null
    },
    fallbackToText: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      iconsPresets: {
        whatsapp: {
          class: 'white--text green accent-4 botter-whatsapp-icon'
        },
        messenger: {
          class: 'white--text blue botter-messenger-icon'
        },
        facebook: {
          class: 'white--text blue botter-messenger-icon'
        },
        twitter: {
          class: 'white--text blue lighten-2 botter-twitter-filled-icon'
        },
        web: {
          class: 'white--text amber botter-web-icon'
        },
        mobile: {
          class: 'white--text purple botter-phone-icon'
        },
        ios: {
          class: 'white--text black botter-ios-icon'
        },
        android: {
          class: 'white--text green botter-andriod-icon'
        },
				'google-reviews': {
        	class: 'white--text  fa fa-google'
				},
				'genesys-skype': {
					class: 'white--text  fa fa-skype'
				},

      },
      channels: {
        'card-text': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-image-url': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-image': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-gallery': {
          channels: ['messenger', 'web', 'mobile']
        },
        'card-video': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-gif': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-suggested': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-go-block': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-audio': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-typing': {
          channels: ['twitter', 'messenger', 'web', 'mobile']
        },
        'card-attribute': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-user-input': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-json': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-random': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-billing': {
          channels: ['messenger', 'web', 'mobile']
        },
        'card-travel': {
          channels: ['messenger', 'web', 'mobile']
        },
        'card-flight': {
          channels: ['web', 'mobile']
        },
        'card-weather': {
          channels: ['web', 'mobile']
        },
        'card-multi-input': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-map': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-date-time-input': {
          channels: ['messenger', 'web', 'mobile']
        },
        'card-escalate': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
        'card-email': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
				'card-attachment': {
					channels: ['whatsapp', 'twitter', 'messenger', 'web']
				},
        'card-end-conversation': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        },
				'card-funnel': {
					channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
				},
				'card-calender-booking': {
					channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
				},
        'card-order': {
          channels: ['whatsapp', 'twitter', 'messenger', 'web', 'mobile']
        }
      }
    }
  },
  computed: {
  	supportedChannels() {
      if (this.manualChannels) return this.manualChannels
  		if (!this.channels[this.slug]) return []
  		return this.channels[this.slug].channels
  	}
  },
  methods: {
    getIcon(channel) {
     const iconProperty = this.iconsPresets[channel]
     return iconProperty ? iconProperty.class : null
    }
  }
}


</script>

<style lang="css" scoped>
.platform-wrapper {
	border-radius: 50%;
	padding: 6px;
	margin-right: 6px;
}
.channels-main-wrapper {
	padding: 0 2rem;
}
.capitalize {
  text-transfrom: capitalize;
}
	.fa-google {
		background: #EA4335 !important;
	}
	.fa-skype {
		background: #00AFF0 !important;
	}
</style>
